export default __webpack_public_path__ + "base-site/media/bg.59b7573f.jpg";